import api from './client';

export async function getApplications() {
  const res = await api.get('/applications');
  return res.data;
}

export async function getPinnedApplications() {
  const res = await api.get('/applications/pinned');
  return res.data;
}

export async function setPinnedApplications(appIdsOrSlugs) {
  const res = await api.put('/applications/pinned', { appIdsOrSlugs });
  return res.data;
}

export async function adminListAllApplications() {
  const res = await api.get('/applications/admin/all');
  return res.data;
}

export async function adminGetPermissionsMatrix() {
  const res = await api.get('/applications/admin/permissions');
  return res.data;
}

export async function adminUpdateUserPermission(userId, appSlugOrId, permissions) {
  const res = await api.put(`/applications/admin/permissions/${userId}`, {
    appSlugOrId,
    permissions,
  });
  return res.data;
}

export async function adminToggleApplication(appId, enabled) {
  const res = await api.patch(`/applications/admin/${appId}/toggle`, { enabled });
  return res.data;
}
